import { useOutletContext } from 'react-router';
import { TosData } from '../interface';

const Terms = () => {
	const context = useOutletContext<TosData | null>();

	return (
		<>
			<div className="terms-content" dangerouslySetInnerHTML={{ __html: context?.tosCtnt || '' }} />
		</>
	);
};

export default Terms;
